import { render, staticRenderFns } from "./home.vue?vue&type=template&id=50649f14&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50649f14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50649f14')) {
      api.createRecord('50649f14', component.options)
    } else {
      api.reload('50649f14', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=50649f14&scoped=true", function () {
      api.rerender('50649f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/home.vue"
export default component.exports